// extracted by mini-css-extract-plugin
export default {"buttonContainer":"Buttons_buttonContainer__0jY4l","link":"Buttons_link__ilBvV"};